'use client';

import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from '@/lib/utils';

function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'group peer disabled:data-[state=unchecked]:border-disable disabled:data-[state=checked]:bg-button-disabled data-[state=checked]:bg-highlighted data-[state=unchecked]:bg-white data-[state=unchecked]:border-highlighted data-[state=unchecked]:border-1  focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-input/80 inline-flex h-5 w-[36px] shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'dark:data-[state=unchecked]:bg-white group-disabled:data-[state=unchecked]:bg-disable data-[state=unchecked]:bg-highlighted dark:data-[state=checked]:bg-primary-foreground bg-white pointer-events-none block size-[14px] rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[18px] data-[state=unchecked]:translate-x-[2px]',
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
